
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"40","viewBox":"0 0 41 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"0.5","width":"40","height":"40","rx":"8","fill":"#4A81F7"}}),_c('g',{attrs:{"clip-path":"url(#clip0_13924_30545)"}},[_c('path',{attrs:{"d":"M22.3273 14.6507C24.2705 16.5939 24.2705 19.7445 22.3273 21.6876C20.3841 23.6308 17.2336 23.6308 15.2904 21.6876C13.3472 19.7445 13.3472 16.5939 15.2904 14.6507C17.2336 12.7076 20.3841 12.7076 22.3273 14.6507","stroke":"white","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M22.292 21.7168L27.167 26.6585","stroke":"white","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_13924_30545"}},[_c('rect',{attrs:{"width":"20","height":"20","fill":"white","transform":"translate(10.5 10)"}})])])])
          )
        }
      }
    